import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {BASE_TEXT} from '../../../style/typography';
import {TARMAC} from '../../../style/colors';
import {PHONE} from '../../../style/breakpoints';
import glamorous from 'glamorous';
import Hint, {ACTIVATE_MODE_HOVER} from '../../popovers/hint';
import {TOP} from '../../../constants/placements';

const Container = glamorous.div({
  display: 'flex',
  padding: 20,
  flexDirection: 'row',
  ' > div:first-of-type': {
    marginLeft: 0
  }
});

const Item = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});

const Stat = glamorous.div({
  ...BASE_TEXT,
  marginTop: 10,
  fontSize: 15,
  color: TARMAC,
  [PHONE]: {
    fontSize: 14
  }
});

const StatsCard = ({items, tooltip = false}) => {
  return (
    <Container>
      {items.map(({icon, stat, label}, index) => (
        <Fragment key={index}>
          {tooltip && (
            <Hint
              activateMode={ACTIVATE_MODE_HOVER}
              placement={TOP}
              anchor={
                <Item key={index}>
                  {icon}
                  <Stat>{stat}</Stat>
                </Item>
              }
              hint={label}
            />
          )}
          {!tooltip && (
            <Item key={index}>
              {icon}
              <Stat>{stat}</Stat>
            </Item>
          )}
        </Fragment>
      ))}
    </Container>
  );
};

StatsCard.propTypes = {
  tooltip: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.element,
      stat: PropTypes.any
    })
  )
};

export default StatsCard;
